var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrbitoLogoWhiteText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 36,
    viewBox: "0 0 139 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C8.05887 0 0 8.05888 0 18C0 27.9411 8.05887 36 18 36H61C51.0589 36 43 27.9411 43 18C43 8.05888 51.0589 0 61 0H18Z",
    fill: "url(#paint0_linear_483_14004)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_483_14004",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 8,
    width: 19,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 8H16V28H35V8Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_483_14004)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_483_14004",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 19,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2422 16.6714H34.9986V24.0594C34.9986 26.2356 33.2537 27.9997 31.1012 27.9997H20.1396C17.9871 27.9997 16.2422 26.2356 16.2422 24.0594V16.6714Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_483_14004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16.4995H35V20.4995H16V16.4995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 30.9995V11.9995H35V30.9995H31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 30.9995L16 11.9995H20V30.9995H16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 23.9995H35V27.9995H16V23.9995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 23.4995V27.9995H16V23.4995H20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20.4995H20V16.4995H16V20.4995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 27.9995V23.4995H31V27.9995H35Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5137 12.7554L16.3263 16.4416L16.1204 15.4032C15.8611 14.0947 16.4968 12.8626 17.5404 12.6511L31.9486 9.73083C32.9922 9.51931 34.0485 10.4085 34.3078 11.7169L34.5137 12.7554Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 18C43.5 8.33502 51.335 0.5 61 0.5H121C130.665 0.5 138.5 8.33502 138.5 18C138.5 27.665 130.665 35.5 121 35.5H61C51.335 35.5 43.5 27.665 43.5 18Z",
    stroke: "url(#paint1_linear_483_14004)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.02 17.5586V18.2324C126.02 19.3132 125.873 20.2832 125.58 21.1426C125.287 22.002 124.874 22.7344 124.34 23.3398C123.806 23.9388 123.168 24.3978 122.426 24.7168C121.69 25.0358 120.873 25.1953 119.975 25.1953C119.083 25.1953 118.266 25.0358 117.523 24.7168C116.788 24.3978 116.15 23.9388 115.609 23.3398C115.069 22.7344 114.649 22.002 114.35 21.1426C114.057 20.2832 113.91 19.3132 113.91 18.2324V17.5586C113.91 16.4714 114.057 15.5013 114.35 14.6484C114.643 13.7891 115.056 13.0566 115.59 12.4512C116.13 11.8457 116.768 11.3835 117.504 11.0645C118.246 10.7454 119.063 10.5859 119.955 10.5859C120.854 10.5859 121.671 10.7454 122.406 11.0645C123.148 11.3835 123.786 11.8457 124.32 12.4512C124.861 13.0566 125.277 13.7891 125.57 14.6484C125.87 15.5013 126.02 16.4714 126.02 17.5586ZM123.061 18.2324V17.5391C123.061 16.7839 122.992 16.1198 122.855 15.5469C122.719 14.974 122.517 14.4922 122.25 14.1016C121.983 13.7109 121.658 13.418 121.273 13.2227C120.889 13.0208 120.45 12.9199 119.955 12.9199C119.46 12.9199 119.021 13.0208 118.637 13.2227C118.259 13.418 117.937 13.7109 117.67 14.1016C117.41 14.4922 117.211 14.974 117.074 15.5469C116.938 16.1198 116.869 16.7839 116.869 17.5391V18.2324C116.869 18.9811 116.938 19.6452 117.074 20.2246C117.211 20.7975 117.413 21.2826 117.68 21.6797C117.947 22.0703 118.272 22.3665 118.656 22.5684C119.04 22.7702 119.48 22.8711 119.975 22.8711C120.469 22.8711 120.909 22.7702 121.293 22.5684C121.677 22.3665 121.999 22.0703 122.26 21.6797C122.52 21.2826 122.719 20.7975 122.855 20.2246C122.992 19.6452 123.061 18.9811 123.061 18.2324Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.57 10.7812V25H105.65V10.7812H108.57ZM112.945 10.7812V13.0762H101.344V10.7812H112.945Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7598 10.7812V25H96.8398V10.7812H99.7598Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4375 18.7598H85.7852L85.7656 16.748H88.832C89.3724 16.748 89.8151 16.6797 90.1602 16.543C90.5052 16.3997 90.7624 16.1947 90.9316 15.9277C91.1074 15.6543 91.1953 15.3223 91.1953 14.9316C91.1953 14.4889 91.1107 14.1309 90.9414 13.8574C90.7786 13.584 90.5215 13.3854 90.1699 13.2617C89.8249 13.138 89.3789 13.0762 88.832 13.0762H86.8008V25H83.8711V10.7812H88.832C89.6589 10.7812 90.3978 10.8594 91.0488 11.0156C91.7064 11.1719 92.263 11.4095 92.7188 11.7285C93.1745 12.0475 93.5228 12.4512 93.7637 12.9395C94.0046 13.4212 94.125 13.9941 94.125 14.6582C94.125 15.2441 93.9915 15.7845 93.7246 16.2793C93.4642 16.7741 93.0508 17.1777 92.4844 17.4902C91.9245 17.8027 91.1921 17.9753 90.2871 18.0078L89.4375 18.7598ZM89.3105 25H84.9844L86.127 22.7148H89.3105C89.8249 22.7148 90.2448 22.6335 90.5703 22.4707C90.8958 22.3014 91.1367 22.0736 91.293 21.7871C91.4492 21.5007 91.5273 21.1719 91.5273 20.8008C91.5273 20.3841 91.4557 20.0228 91.3125 19.7168C91.1758 19.4108 90.9544 19.1764 90.6484 19.0137C90.3424 18.8444 89.9388 18.7598 89.4375 18.7598H86.6152L86.6348 16.748H90.1504L90.8242 17.5391C91.6901 17.526 92.3867 17.679 92.9141 17.998C93.4479 18.3105 93.8353 18.7174 94.0762 19.2188C94.3236 19.7201 94.4473 20.2572 94.4473 20.8301C94.4473 21.7415 94.2487 22.5098 93.8516 23.1348C93.4544 23.7533 92.8717 24.2188 92.1035 24.5312C91.3418 24.8438 90.4108 25 89.3105 25Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0586 10.7812H76.3613C77.4486 10.7812 78.3828 10.944 79.1641 11.2695C79.9518 11.5951 80.5573 12.0768 80.9805 12.7148C81.4036 13.3529 81.6152 14.1374 81.6152 15.0684C81.6152 15.8301 81.485 16.4844 81.2246 17.0312C80.9707 17.5716 80.6094 18.0241 80.1406 18.3887C79.6784 18.7467 79.1348 19.0332 78.5098 19.248L77.582 19.7363H72.9727L72.9531 17.4512H76.3809C76.8952 17.4512 77.3216 17.36 77.6602 17.1777C77.9987 16.9954 78.2526 16.7415 78.4219 16.416C78.5977 16.0905 78.6855 15.7129 78.6855 15.2832C78.6855 14.8275 78.6009 14.4336 78.4316 14.1016C78.2624 13.7695 78.0052 13.5156 77.6602 13.3398C77.3151 13.1641 76.8822 13.0762 76.3613 13.0762H73.9883V25H71.0586V10.7812ZM79.0078 25L75.7656 18.6621L78.8613 18.6426L82.1426 24.8633V25H79.0078Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9492 17.5586V18.2324C68.9492 19.3132 68.8027 20.2832 68.5098 21.1426C68.2168 22.002 67.8034 22.7344 67.2695 23.3398C66.7357 23.9388 66.0977 24.3978 65.3555 24.7168C64.6198 25.0358 63.8027 25.1953 62.9043 25.1953C62.0124 25.1953 61.1953 25.0358 60.4531 24.7168C59.7174 24.3978 59.0794 23.9388 58.5391 23.3398C57.9987 22.7344 57.5788 22.002 57.2793 21.1426C56.9863 20.2832 56.8398 19.3132 56.8398 18.2324V17.5586C56.8398 16.4714 56.9863 15.5013 57.2793 14.6484C57.5723 13.7891 57.9857 13.0566 58.5195 12.4512C59.0599 11.8457 59.6979 11.3835 60.4336 11.0645C61.1758 10.7454 61.9928 10.5859 62.8848 10.5859C63.7832 10.5859 64.6003 10.7454 65.3359 11.0645C66.0781 11.3835 66.7161 11.8457 67.25 12.4512C67.7904 13.0566 68.207 13.7891 68.5 14.6484C68.7995 15.5013 68.9492 16.4714 68.9492 17.5586ZM65.9902 18.2324V17.5391C65.9902 16.7839 65.9219 16.1198 65.7852 15.5469C65.6484 14.974 65.4466 14.4922 65.1797 14.1016C64.9128 13.7109 64.5872 13.418 64.2031 13.2227C63.819 13.0208 63.3796 12.9199 62.8848 12.9199C62.39 12.9199 61.9505 13.0208 61.5664 13.2227C61.1888 13.418 60.8665 13.7109 60.5996 14.1016C60.3392 14.4922 60.1406 14.974 60.0039 15.5469C59.8672 16.1198 59.7988 16.7839 59.7988 17.5391V18.2324C59.7988 18.9811 59.8672 19.6452 60.0039 20.2246C60.1406 20.7975 60.3424 21.2826 60.6094 21.6797C60.8763 22.0703 61.2018 22.3665 61.5859 22.5684C61.9701 22.7702 62.4095 22.8711 62.9043 22.8711C63.3991 22.8711 63.8385 22.7702 64.2227 22.5684C64.6068 22.3665 64.929 22.0703 65.1895 21.6797C65.4499 21.2826 65.6484 20.7975 65.7852 20.2246C65.9219 19.6452 65.9902 18.9811 65.9902 18.2324Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_483_14004",
    x1: 14.5,
    y1: 39,
    x2: 51.5,
    y2: 0.00000101362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_483_14004",
    x1: 91,
    y1: 0,
    x2: 91,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbitoLogoWhiteText);
export default __webpack_public_path__ + "static/media/Orbito_Logo_WhiteText.fcf6fca43f85f31d81940cb55d6ff29b.svg";
export { ForwardRef as ReactComponent };